import { ErrorType } from 'data/App/types'

import { FETCH_PAYMENT, FETCH_PAYMENT_ERROR, FETCH_PAYMENT_SUCCESS } from './actionTypes'
import { Payment } from './types'

type FetchPaymentAction = {
  payload: { id: string }
  type: typeof FETCH_PAYMENT
}
export const fetch = (id: string): FetchPaymentAction => ({
  payload: { id },
  type: FETCH_PAYMENT
})

type FetchSuccessPaymentAction = {
  payload: { data: Payment; id: string }
  type: typeof FETCH_PAYMENT_SUCCESS
}
export const fetchSuccess = (id: string, data: Payment): FetchSuccessPaymentAction => ({
  payload: { data, id },
  type: FETCH_PAYMENT_SUCCESS
})

type FetchErrorPaymentAction = {
  payload: { error: ErrorType; id: string }
  type: typeof FETCH_PAYMENT_ERROR
}
export const fetchError = (id: string, error: ErrorType): FetchErrorPaymentAction => ({
  payload: { error, id },
  type: FETCH_PAYMENT_ERROR
})

export type PaymentActions =
  | FetchPaymentAction
  | FetchSuccessPaymentAction
  | FetchErrorPaymentAction
